import { includes } from 'lodash'

const validateComponentIngredient = (
  value,
  otherComponentIngredientFieldName,
  getFieldValue,
) => {
  const otherComponentIngredientIds = getFieldValue(
    otherComponentIngredientFieldName,
  )

  if (includes(otherComponentIngredientIds, value)) {
    throw new Error(
      `Item is already present in ${otherComponentIngredientFieldName}`,
    )
  }
}

export default validateComponentIngredient
